import logoHeader from "./images/logo-header.png";
import Thai from "./images/thai.png";
import Eng from "./images/eng.png";
import China from "./images/china.png";
import logoGreen from "./images/logo-green.svg";
import Mascotte from "./images/mascotte.png";
import LoginImg from "./images/login-img.png";
import LogoPila from "./images/logo-pila.png";
export { logoHeader, Thai, Eng, China, logoGreen, Mascotte, LoginImg, LogoPila };

import THFindTheMatch from "./images/games/th/findthematch.png";
import THGameshowQuiz from "./images/games/th/gameshowquiz.png";
import THFlipCards from "./images/games/th/flipcards.png";
import THAirPlanFlyingFruits from "./images/games/th/airplanflyingfruits.png";
import THFlappyBird from "./images/games/th/flappybird.png";
import THWhackAMole from "./images/games/th/whackamole.png";
import THAnagram from "./images/games/th/anagram.png";
import THCompleteTheSentence from "./images/games/th/completethesentence.png";
import THSituation from "./images/games/th/situation.png";
import THSequence from "./images/games/th/sequence.png";
export {  THFindTheMatch, THGameshowQuiz, THFlipCards, THAirPlanFlyingFruits, THFlappyBird, THWhackAMole, THAnagram, THCompleteTheSentence, THSituation, THSequence };

import ENFindTheMatch from "./images/games/en/findthematch.png";
import ENGameshowQuiz from "./images/games/en/gameshowquiz.png";
import ENFlipCards from "./images/games/en/flipcards.png";
import ENAirPlanFlyingFruits from "./images/games/en/airplanflyingfruits.png";
import ENFlappyBird from "./images/games/en/flappybird.png";
import ENWhackAMole from "./images/games/en/whackamole.png";
import ENAnagram from "./images/games/en/anagram.png";
import ENCompleteTheSentence from "./images/games/en/completethesentence.png";
import ENSituation from "./images/games/en/situation.png";
import ENSequence from "./images/games/en/sequence.png";
export {  ENFindTheMatch, ENGameshowQuiz, ENFlipCards, ENAirPlanFlyingFruits, ENFlappyBird, ENWhackAMole, ENAnagram, ENCompleteTheSentence, ENSituation, ENSequence };

import SmFindTheMatch from "./images/games/small/findthematch.png";
import SmGameshowQuiz from "./images/games/small/gameshowquiz.png";
import SmFlipCards from "./images/games/small/flipcards.png";
import SmAirPlanFlyingFruits from "./images/games/small/airplanflyingfruits.png";
import SmFlappyBird from "./images/games/small/flappybird.png";
import SmWhackAMole from "./images/games/small/whackamole.png";
import SmAnagram from "./images/games/small/anagram.png";
import SmCompleteTheSentence from "./images/games/small/completethesentence.png";
export { SmFindTheMatch, SmGameshowQuiz, SmFlipCards, SmAirPlanFlyingFruits, SmFlappyBird, SmWhackAMole, SmAnagram, SmCompleteTheSentence };

import ThumnailFindTheMatch from "./images/thumbnail/findthematch.png";
import ThumnailGameshowQuiz from "./images/thumbnail/gameshow.png";
import ThumnailFlipCards from "./images/thumbnail/flipcard.png";
import ThumnailAirPlanFlyingFruits from "./images/thumbnail/flyingfruit.png";
import ThumnailFlappyBird from "./images/thumbnail/flappybird.png";
import ThumnailWhackAMole from "./images/thumbnail/whackamole.png";
import ThumnailAnagram from "./images/thumbnail/anagram.png";
import ThumnailCompleteTheSentence from "./images/thumbnail/completethesentence.png";
import ThumnailSituation from "./images/thumbnail/situation.png";
import ThumnailSequence from "./images/thumbnail/sequence.png";
export { ThumnailFindTheMatch, ThumnailGameshowQuiz, ThumnailFlipCards, ThumnailAirPlanFlyingFruits, ThumnailFlappyBird, ThumnailWhackAMole, ThumnailAnagram, ThumnailCompleteTheSentence, ThumnailSituation, ThumnailSequence };

import GameCreationImage1 from "./images/userGuide/gameCreation/image1.png";
import GameCreationImage2 from "./images/userGuide/gameCreation/image2.png";
import GameCreationImage3 from "./images/userGuide/gameCreation/image3.png";
import GameCreationImage4 from "./images/userGuide/gameCreation/image4.png";
import GameCreationImage5 from "./images/userGuide/gameCreation/image5.png";
import GameCreationImage6 from "./images/userGuide/gameCreation/image6.png";
export { GameCreationImage1, GameCreationImage2, GameCreationImage3, GameCreationImage4, GameCreationImage5, GameCreationImage6 };

import LessonSequenceImage1 from "./images/userGuide/lessonSequence/image1.png";
import LessonSequenceImage2 from "./images/userGuide/lessonSequence/image2.png";
import LessonSequenceImage3 from "./images/userGuide/lessonSequence/image3.png";
import LessonSequenceImage4 from "./images/userGuide/lessonSequence/image4.png";
import LessonSequenceImage5 from "./images/userGuide/lessonSequence/image5.png";
import LessonSequenceImage6 from "./images/userGuide/lessonSequence/image6.png";
import LessonSequenceImage7 from "./images/userGuide/lessonSequence/image7.png";
import LessonSequenceImage8 from "./images/userGuide/lessonSequence/image8.png";
import LessonSequenceImage9 from "./images/userGuide/lessonSequence/image9.png";
import LessonSequenceImage10 from "./images/userGuide/lessonSequence/image10.png";
export { LessonSequenceImage1, LessonSequenceImage2, LessonSequenceImage3, LessonSequenceImage4, LessonSequenceImage5, LessonSequenceImage6, LessonSequenceImage7, LessonSequenceImage8, LessonSequenceImage9, LessonSequenceImage10 };

import LiveDashboardImage1 from "./images/userGuide/howToUseLiveDashboard/image1.png";
import LiveDashboardImage2 from "./images/userGuide/howToUseLiveDashboard/image2.png";
import LiveDashboardImage3 from "./images/userGuide/howToUseLiveDashboard/image3.png";
import LiveDashboardImage4 from "./images/userGuide/howToUseLiveDashboard/image4.png";
import LiveDashboardImage5 from "./images/userGuide/howToUseLiveDashboard/image5.png";
import LiveDashboardImage6 from "./images/userGuide/howToUseLiveDashboard/image6.png";
import LiveDashboardImage7 from "./images/userGuide/howToUseLiveDashboard/image7.png";
import LiveDashboardImage8 from "./images/userGuide/howToUseLiveDashboard/image8.png";
import LiveDashboardImage9 from "./images/userGuide/howToUseLiveDashboard/image9.png";
import LiveDashboardImage10 from "./images/userGuide/howToUseLiveDashboard/image10.png";
import LiveDashboardImage11 from "./images/userGuide/howToUseLiveDashboard/image11.png";
export { LiveDashboardImage1, LiveDashboardImage2, LiveDashboardImage3, LiveDashboardImage4, LiveDashboardImage5, LiveDashboardImage6, LiveDashboardImage7, LiveDashboardImage8, LiveDashboardImage9, LiveDashboardImage10, LiveDashboardImage11 };

import LivePerformanceImage1 from "./images/userGuide/howToUseLivePerformance/image1.png";
import LivePerformanceImage2 from "./images/userGuide/howToUseLivePerformance/image2.png";
import LivePerformanceImage3 from "./images/userGuide/howToUseLivePerformance/image3.png";
import LivePerformanceImage4 from "./images/userGuide/howToUseLivePerformance/image4.png";
import LivePerformanceImage5 from "./images/userGuide/howToUseLivePerformance/image5.png";
import LivePerformanceImage6 from "./images/userGuide/howToUseLivePerformance/image6.png";
import LivePerformanceImage7 from "./images/userGuide/howToUseLivePerformance/image7.png";
import LivePerformanceImage8 from "./images/userGuide/howToUseLivePerformance/image8.png";
import LivePerformanceImage9 from "./images/userGuide/howToUseLivePerformance/image9.png";
import LivePerformanceImage10 from "./images/userGuide/howToUseLivePerformance/image10.png";
import LivePerformanceImage11 from "./images/userGuide/howToUseLivePerformance/image11.png";
import LivePerformanceImage12 from "./images/userGuide/howToUseLivePerformance/image12.png";
export { LivePerformanceImage1, LivePerformanceImage2, LivePerformanceImage3, LivePerformanceImage4, LivePerformanceImage5, LivePerformanceImage6, LivePerformanceImage7, LivePerformanceImage8, LivePerformanceImage9, LivePerformanceImage10, LivePerformanceImage11, LivePerformanceImage12 };